type SchemaType = 'Array' | 'Map';

export function parseLeanSchemaRef(renderedSchemaName: string = ''): {
  schemaName: string;
  schemaType?: SchemaType;
} {
  const [typeOrName, schemaName] = getSchemaNameAndType(renderedSchemaName);

  if (schemaName) {
    return {
      schemaName,
      schemaType: typeOrName as SchemaType,
    };
  }

  return {
    schemaName: typeOrName,
  };
}

// if there is no type, returns only the name
const getSchemaNameAndType = (leanSchema: string): string[] =>
  leanSchema.split('#');
